import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { TeamsStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

export const getters = {
  isLoading: (state: TeamsStore): TeamsStore['loading'] => state.loading,
  isSaving: (state: TeamsStore): TeamsStore['saving'] => state.saving,
  getTeams: (state: TeamsStore): TeamsStore['teams'] => state.teams,
  hasTeams: (state: TeamsStore): boolean => isFullArray(state.teams),
  getMeta: (state: TeamsStore): Meta | null => state.meta,
  getUsers: (state: TeamsStore): TeamsStore['users'] => state.users,
  getFilterSearch: (state: TeamsStore): TeamsStore['filterSearch'] => state.filterSearch,
  getCurrentPage: (state: TeamsStore): TeamsStore['currentPage'] => state.currentPage,
  getPerPage: (state: TeamsStore): TeamsStore['perPage'] => state.perPage,
  getTeamToDelete: (state: TeamsStore): TeamsStore['teamToDelete'] => state.teamToDelete,
  isModalDelete: (state: TeamsStore): boolean => state.teamToDelete !== null,
  getCurrentTeam: (state: TeamsStore): TeamsStore['currentTeam'] => state.currentTeam,
}
